import * as React from "react";
const SvgLinkedin = () => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M23.44 8.266H9.424a1.08 1.08 0 0 0-1.078 1.078V23.36a1.08 1.08 0 0 0 1.078 1.079H23.44a1.08 1.08 0 0 0 1.079-1.079V9.344a1.08 1.08 0 0 0-1.079-1.078M13.137 22.063h-2.433V14.33h2.433zM11.92 13.27a1.415 1.415 0 1 1 .009-2.83 1.415 1.415 0 0 1-.01 2.83m10.238 8.794h-2.384v-3.74c0-.91 0-2.022-1.266-2.022s-1.42.961-1.42 1.971v3.842h-2.381V14.33h2.23v1.062h.05a2.53 2.53 0 0 1 2.281-1.264c2.433 0 2.89 1.618 2.89 3.69z"
  }
));
export default SvgLinkedin;
